export default __webpack_public_path__ + "static/media/roadmap-d-4.46e6d1ff.png";